var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","clipped-left":"","color":"secondary","dark":""}},[_c('v-app-bar-nav-icon',{attrs:{"color":"white"},on:{"click":function($event){$event.stopPropagation();return _vm.onchangeDrawer.apply(null, arguments)}}}),_c('v-app-bar-title',[_c('span',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.appName))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }